import { render, staticRenderFns } from "./Brian.vue?vue&type=template&id=2c67f049"
import script from "./Brian.vue?vue&type=script&lang=js"
export * from "./Brian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports